import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Gstr2BResponse, GstrReconciliation, SuppliersReport } from '../../../matching/models/gstr-2b-response.model';

@Component({
  selector: 'app-response-table',
  templateUrl: './response-table.component.html',
  styleUrl: './response-table.component.scss'
})
export class ResponseTableComponent implements OnChanges  {
  @Input() input: Gstr2BResponse | undefined;
  reconciliation: GstrReconciliation | undefined;
  suppliers_report: SuppliersReport | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['input']?.currentValue) {
      this.reconciliation = this.getReconciliation();
      this.suppliers_report = this.getSuppliersReport();
    }
  }

  getReconciliation(){
    return this.input?.stats["gstr_reconciliation"];
  }

  getSuppliersReport() {
    return this.input?.suppliersReport;
  }

}
